import BannerContent from './ui/BannerContent';
import BannerDescription from './ui/BannerDescription';
import BannerImage from './ui/BannerImage';
import BannerTitle from './ui/BannerTitle';
import MainBanner from './ui/MainBanner';
import MedicalCategorySection from './ui/MedicalCategorySection';

export { MainBanner, BannerContent, BannerImage, BannerTitle, BannerDescription, MedicalCategorySection };
